import moment from 'moment'
import {
    UpdateMethodsActive,
    UpdateMethodCodeActive,
    UpdateMethodsDetails,
    UpdateDepositBankActive,
    UpdateDepositMemberBanksActive,
    UpdateDepositPayments,
    UpdateDepositMoneyStatus,
    UpdateDepositOldBankSixNumberStatus,
    UpdateDepositCardNumber_CC,
    UpdateDepositCardPIN_CC,
    UpdateDepositDateSelect,
    UpdateDepositTimeSelect,
    UpdateUploadFileList,
    UpdateMenber,
    UpdateLBOfflineRefNo,
    UpdateDepositAccountByAmountValues
} from '../actions/DepositUpdate'
//存款方式
export const Methods = (state = {}, action) => {
    switch (action.type) {
        case 'METHODS':
            return state = action.data || {}
        default:
            return state
    }
}
//设置当前存款方式
export const MethodsActive = (state = {}, action) => {
    switch (action.type) {
        case 'METHODS_ACTIVE':
            UpdateMethodsActive(action.data || {})
            return state = action.data || {}
        default:
            return state
    }
}
//当前存款渠道
export const MethodCodeActive = (state = '', action) => {
    switch (action.type) {
        case 'METHOD_CODE_ACTIVE':
            UpdateMethodCodeActive(action.data || '')
            return state = action.data || ''
        default:
            return state
    }
}

//存款详情信息
export const MethodsDetails = (state = {}, action) => {
    switch (action.type) {
        case 'METHODS_DETAILS':
            UpdateMethodsDetails(action.data || {})
            return state = action.data || {}
        default:
            return state
    }
}
//特殊金额list
export const SuggestedAmounts = (state = [], action) => {
    switch (action.type) {
        case 'SUGGESTED_AMOUNTS':
            return state = action.data || []
        default:
            return state
    }
}
//存款金额和状态
export const DepositMoneyStatus = (state = { money: '', moneyErrMsg: '' }, action) => {
    switch (action.type) {
        case 'DEPOSIT_MONEY_STATUS':
            UpdateDepositMoneyStatus(action.data || { money: '', moneyErrMsg: '' })
            return state = action.data || { money: '', moneyErrMsg: '' }
        default:
            return state
    }
}
//oldBank存款旧账户后6位数和状态
export const DepositOldBankSixNumberStatus = (state = { numCode: '', codeErrMsg: '' }, action) => {
    switch (action.type) {
        case 'DEPOSIT_OLD_BANK_SIX_NUMBER_STATUS':
            UpdateDepositOldBankSixNumberStatus(action.data || { numCode: '', codeErrMsg: '' })
            return state = action.data || { numCode: '', codeErrMsg: '' }
        default:
            return state
    }
}
// 选中存款银行信息，使用bankAccounts还是banks
export const BanksBankAccounts = (state = [], action) => {
    switch (action.type) {
        case 'BANKS_BANKACCOUNTS':
            return state = action.data || []
        default:
            return state
    }
}
//银行搜索数据
export const DepositBankSearch = (state = '', action) => {
    switch (action.type) {
        case 'DEPOSIT_BANK_SEARCH':
            return state = action.data || ''
        default:
            return state
    }
}
//选中的存款银行
export const DepositBankActive = (state = {}, action) => {
    switch (action.type) {
        case 'DEPOSIT_BANK_ACTIVE':
            UpdateDepositBankActive(action.data || {})
            return state = action.data || {}
        default:
            return state
    }
}
// 用户存款银行信息
export const DepositMemberBanks = (state = [], action) => {
    switch (action.type) {
        case 'DEPOSIT_MEMBER_BANKS':
            return state = action.data || []
        default:
            return state
    }
}

// 选中用户存款银行信息
export const DepositMemberBanksActive = (state = {}, action) => {
    switch (action.type) {
        case 'DEPOSIT_MEMBER_BANKS_ACTIVE':
            UpdateDepositMemberBanksActive(action.data || {})
            return state = action.data || {}
        default:
            return state
    }
}
//存款提交成功后显示下一步
export const DepositNextStep = (state = false, action) => {
    switch (action.type) {
        case 'DEPOSIT_NEXT_STEP':
            return state = action.data || false
        default:
            return state
    }
}
//存款提交api返回数据
export const DepositPayments = (state = {}, action) => {
    switch (action.type) {
        case 'CLEAR_DEPOSIT_PAYMENTS':
            //存款成功，删除数据
            UpdateDepositPayments({})
            return state = ''
        case 'DEPOSIT_PAYMENTS':
            UpdateDepositPayments(action.data || {})
            return state = action.data || ''
        default:
            return state
    }
}
// const dateSelect = ''
const dateSelect = moment(new Date()).format('YYYY-MM-DD')
//存款日期
export const DepositDateSelect = (state = dateSelect, action) => {
    switch (action.type) {
        case 'DEPOSIT_DATE_SELECT':
            UpdateDepositDateSelect(action.data || dateSelect)
            return state = action.data || dateSelect
        default:
            return state
    }
}
// const timeSelect = ''
const timeSelect = '00:00'
//存款日期
export const DepositTimeSelect = (state = timeSelect, action) => {
    switch (action.type) {
        case 'DEPOSIT_TIME_SELECT':
            UpdateDepositTimeSelect(action.data || timeSelect)
            return state = action.data || timeSelect
        default:
            return state
    }
}
//上传图片List
export const UploadFileList = (state = [], action) => {
    switch (action.type) {
        case 'UPLOAD_FILE_LIST':
            UpdateUploadFileList(action.data || [])
            return state = action.data || []
        default:
            return state
    }
}
//上传图片错误提示
export const UploadFileErr = (state = '', action) => {
    switch (action.type) {
        case 'UPLOAD_FILE_ERR':
            return state = action.data || ''
        default:
            return state
    }
}
//上传图片api返回数据
export const UploadFileStatus = (state = {}, action) => {
    switch (action.type) {
        case 'POST_UPLOAD_FILE':
            return state = action.data || {}
        default:
            return state
    }
}
//成功页面状态
export const DepositSuccessPage = (state = false, action) => {
    switch (action.type) {
        case 'DEPOSIT_SUCCESS_PAGE':
            return state = action.data || false
        default:
            return state
    }
}
//CC卡号
export const DepositCardNumber_CC = (state = { number: '', numberErrMsg: '' }, action) => {
    switch (action.type) {
        case 'DEPOSIT_CARD_NUMBER_CC':
            UpdateDepositCardNumber_CC(action.data || { number: '', numberErrMsg: '' })
            return state = action.data || { number: '', numberErrMsg: '' }
        default:
            return state
    }
}
//CC卡密码
export const DepositCardPIN_CC = (state = { PIN: '', PINErrMsg: '' }, action) => {
    switch (action.type) {
        case 'DEPOSIT_CARD_PIN_CC':
            UpdateDepositCardPIN_CC(action.data || { PIN: '', PINErrMsg: '' })
            return state = action.data || { PIN: '', PINErrMsg: '' }
        default:
            return state
    }
}
//取消存款
export const MemberCancelDeposit = (state = false, action) => {
    switch (action.type) {
        case 'MEMBER_CANCEL_DEPOSIT':
            return state = action.data || false
        default:
            return state
    }
}
//显示oldbank存款
export const DepositOldBank = (state = false, action) => {
    switch (action.type) {
        case 'DEPOSIT_OLD_BANK':
            return state = action.data || false
        default:
            return state
    }
}
export const RemoveAllReducersState = (state = false, action) => {
    switch (action.type) {
        case 'REMOVE_ALL_REDUCERS':
            return state = action.data || false
        default:
            return state
    }
}
export const CopyKey = (state = '', action) => {
    switch (action.type) {
        case 'COPY_KEY':
            return state = action.data || ''
        default:
            return state
    }
}
export const DepositAccountByAmount = (state = '', action) => {
    switch (action.type) {
        case 'DEPOSIT_ACCOUNT_BY_AMOUNT':
            UpdateDepositAccountByAmountValues(action.data || "")
            return state = action.data || ''
        default:
            return state
    }
}
//公告消息
export const Announcement = (state = {}, action) => {
    switch (action.type) {
        case 'ANNOUNCEMENT_POPUP':
            return state = action.data || {}
        default:
            return state
    }
}

//Member信息
export const MemberInfo = (state = {}, action) => {
    switch (action.type) {
        case 'MEMBERINFO':
            UpdateMenber(action.data || {})
            return state = action.data || {}
        default:
            return state
    }
}
//otp
export const LoginOTP = (state = false, action) => {
    switch (action.type) {
        case 'LOGIN_OTP':
            return state = action.data || false
        default:
            return state
    }
}
export const LBOfflineRefNo = (state = {refNo: '', refNoErrMsg: ''}, action) => {
    switch (action.type) {
        case 'LBOFFLINEREFNO':
            UpdateLBOfflineRefNo(action.data || { refNo: '', refNoErrMsg: '' })
            return state = action.data || { refNo: '', refNoErrMsg: '' }
        default:
            return state
    }
}


//存款详情信息
export const DepositBouns = (state = {}, action) => {
    switch (action.type) {
        case 'DEPOSIT_BOUNS':
            return state = action.data || {}
        default:
            return state
    }
}

//存款觸發Module
export const DepositTriggerFrom = (state = {}, action) => {
    switch (action.type) {
        case 'DEPOSIT_TRIGGER':
            return state = action.data || {}
        default:
            return state
    }
}


// 泰达币额外添加查询INVOICE汇率 
export const InvoiceExchangerate = (state = {}, action) => {
    switch (action.type) {
        case 'INVOICE_EXCHANGERATE':
            return state = action.data || {}
        default:
            return state
    }
}